// extracted by mini-css-extract-plugin
export default {"list":"SubmitSwal_list__4Tbny","full_width":"SubmitSwal_full_width__JUay0","slots_list":"SubmitSwal_slots_list__kZFTU","slot":"SubmitSwal_slot__UbjwK"};